module.exports = __webpack_public_path__ + "img/ramrest.7635608e.png";